import React, { useState } from 'react';
import { message } from 'antd';
import PlanCard from './PlanCard';
import IncludedFeaturesGrid from './IncludedFeaturesGrid';
import ValueSidebar from './ValueSidebar';
import styles from './PlanTermsStep.module.css';

const PlanTermsStep = ({ onNext, dealershipData }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleContinue = () => {
    if (isProcessing) return;
    const dealershipName = dealershipData?.name || dealershipData?.dealershipName || '';
    if (!dealershipName || !dealershipName.trim()) {
      message.error('Dealership name is required. Please go back and fill it in.');
      return;
    }
    onNext(dealershipData);
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.mainGrid}>
        <div className={styles.leftCol}>
          <PlanCard onStartTrial={handleContinue} isProcessing={isProcessing}>
            <IncludedFeaturesGrid />
          </PlanCard>
        </div>
        <ValueSidebar />
      </div>
    </div>
  );
};

export default PlanTermsStep;
